export const SELF_REP_SL_EMAIL = "enquiries@spotlight.com";

export const SOCIAL_MEDIA_POST_MESSAGE_AUTH_COMPLETE =
  "SOCIAL_MEDIA_POST_MESSAGE_AUTH_COMPLETE";

export const MY_HOME_PATH = "/myhome";

export const MY_HOME_ERROR_CODES_REDIRECTION = [400, 403, 404];

export const PROFILE_EDIT_VIEW_QUERY_PARAM = "edit";
